import { inject } from "@angular/core";
import { StringHelpers } from "../shared/helpers/string-helpers";
import { FormGroup } from "@angular/forms";

export class BaseModalComponent {
  public isLoading: boolean = false;
  public isDarkMode: boolean = false;
  protected stringHelpers = inject(StringHelpers);

  setError(err: any, form: any){
    if (err.status === 400) {
      const validationErrors = err.error;

      Object.keys(validationErrors).forEach(prop => {
        const formControl = form.get(this.stringHelpers.camelize(prop));

        if (formControl) {
          formControl.setErrors({ validationErrors: validationErrors[prop] });
        }
      });
    }
  }

  setErrorV2(err: any, form: FormGroup){
    if (err.status === 400) {
      const validationErrors = err.error;

      validationErrors.forEach(prop => {
        const formControl = form.get(this.stringHelpers.camelize(prop.propertyName));
        if (formControl) {
          formControl.setErrors({ validationErrors: prop.errorMessage });
        }
      });
    }
  }
}